<p-toast [baseZIndex]="100000" position="top-right"></p-toast>
<div *ngIf="loading || iniciandoPortal" class="overlay">
    <div class="spinner-container">
        <p-progressSpinner></p-progressSpinner>
    </div>
</div>

<ng-container *ngIf="!iniciandoPortal">
    <ng-container *ngIf="bloqueado">
        <div class="card">
            <div class="grid">
                <div class="col-12 flex justify-content-center">
                    <h5 class="text-bloqueado">
                        No habilitado para cobros, realice una acreditación o
                        comuníquese con su soporte...
                    </h5>
                </div>
                <div class="col-12 flex justify-content-center">
                    <img
                        class="imagen-bloqueado"
                        src="./assets/images/finamsa/logo-dark.png"
                        alt="logo"
                    />
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="!bloqueado">
        <div
            class="grid p-2 flex justify-content-center align-items-center"
            *ngIf="!aperturar"
        >
            <div class="col-12 md:col-10">
                <form [formGroup]="formGroup">
                    <div class="p-fluid p-formgrid grid mt-0">
                        <input
                            class="buscar"
                            #vcBuscar
                            placeholder="Buscar Comercios..."
                            type="text"
                            pInputText
                            formControlName="buscar"
                            (keypress)="onBuscar($event)"
                            (keydown)="onBuscar($event)"
                        />
                    </div>
                </form>
            </div>
            <div class="col-12 md:col-2 p-fluid" *ngIf="cierre">
                <p-button
                    icon="pi pi-times"
                    label="CERRAR CAJA"
                    severity="danger"
                    (onClick)="cerrarCaja()"
                ></p-button>
            </div>
        </div>

        <div class="grid pt-2" *ngIf="!aperturar">
            <ng-container *ngFor="let comercio of comerciosFiltrados">
                <div class="p-1 col-3 md:col-2">
                    <div
                        class="card comercio-card p-1"
                        (click)="onComercio(comercio)"
                    >
                        <div
                            class="flex justify-content-center comercio-card-logo"
                        >
                            <img
                                [src]="getUrlImage(comercio)"
                                alt="{{ comercio.imagen }}"
                                style="width: 6rem"
                            />
                        </div>
                        <div
                            class="flex align-items-center justify-content-center p-1"
                        >
                            <span class="nombre-comercio">{{
                                comercio.nombre
                            }}</span>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>

        <!-- Modal Servicios -->
        <p-dialog
            header="{{ comercioSeleccionado?.nombre }} - SERVICIOS"
            [(visible)]="showModalServicio"
            [modal]="true"
            [style]="{ width: '90vw', minWidth: '90vw' }"
            [maximizable]="false"
            [baseZIndex]="10000"
            [closable]="false"
            appendTo="body"
            [closable]="true"
            [draggable]="false"
            [closeOnEscape]="false"
            (onHide)="resetearValores()"
        >
            <p-toast
                key="td"
                [baseZIndex]="100000"
                position="top-center"
                [life]="8000"
            ></p-toast>
            <div *ngIf="loadingServicio" class="overlay">
                <div class="spinner-container">
                    <p-progressSpinner></p-progressSpinner>
                </div>
            </div>
            <ng-container>
                <div class="grid p-1">
                    <div
                        *ngFor="let servicio of servicios; let i = index"
                        class="col-12 md:col-4"
                    >
                        <div class="container">
                            <div
                                class="servicio-card"
                                (click)="onServicio(servicio)"
                            >
                                <span class="nombre-servicio"
                                    >{{ i + 1 }} - {{ servicio.nombre }}</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="fgCobro">
                <div
                    *ngIf="servicioSeleccionado"
                    class="grid flex justify-content-center servicio-disponible"
                >
                    {{ servicioSeleccionado.nombre | uppercase }}
                </div>
                <ng-container>
                    <form [formGroup]="fgCobro">
                        <div class="p-fluid p-formgrid grid p-2 campos-cobro">
                            <ng-container *ngFor="let campo of campos">
                                <div class="field col-12 md:col-4 p-1 mb-0">
                                    <label
                                        htmlFor="campo.nombre"
                                        class="etiqueta"
                                        >{{ campo.etiqueta }}</label
                                    >
                                    <ng-container *ngIf="campo.tipo === 'TEXT'">
                                        <input
                                            pInputText
                                            [id]="campo.nombre"
                                            type="text"
                                            [formControlName]="campo.nombre"
                                            [autofocus]="true"
                                        />
                                    </ng-container>
                                    <ng-container
                                        *ngIf="
                                            campo.tipo === 'AMOUNT' &&
                                            (campo.habilitar_decimales ===
                                                false ||
                                                campo.habilitar_decimales ===
                                                    undefined)
                                        "
                                    >
                                        <p-inputNumber
                                            [inputId]="campo.nombre"
                                            [formControlName]="campo.nombre"
                                        ></p-inputNumber>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="
                                            campo.tipo === 'AMOUNT' &&
                                            campo.habilitar_decimales === true
                                        "
                                    >
                                        <p-inputNumber
                                            [inputId]="campo.nombre"
                                            [formControlName]="campo.nombre"
                                            mode="decimal"
                                            [minFractionDigits]="2"
                                            [maxFractionDigits]="2"
                                        ></p-inputNumber>
                                    </ng-container>
                                    <ng-container *ngIf="campo.tipo === 'DATE'">
                                        <p-calendar
                                            [inputId]="campo.nombre"
                                            [formControlName]="campo.nombre"
                                            [showTime]="false"
                                            dateFormat="dd/mm/yy"
                                            appendTo="body"
                                        ></p-calendar>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="campo.tipo === 'OPTION'"
                                    >
                                        <p-dropdown
                                            [options]="campo.opciones"
                                            [formControlName]="campo.nombre"
                                            optionLabel="nombre"
                                            optionValue="valor"
                                            appendTo="body"
                                        ></p-dropdown>
                                    </ng-container>
                                    <small
                                        *ngIf="invalidControl(campo.nombre)"
                                        class="campo-invalido"
                                        >Este campo es requerido.</small
                                    >
                                </div>
                            </ng-container>
                        </div>
                        <!-- Para mostrar campos adicionales necesarios para completar la transaccion -->
                        <ng-container *ngIf="mostrarCamposAdicionales">
                            <div
                                class="grid flex justify-content-center servicio-disponible-opcional"
                            >
                                {{
                                    "Complete la siguiente informacion"
                                        | uppercase
                                }}
                            </div>
                            <div class="p-fluid p-formgrid grid p-2">
                                <ng-container
                                    *ngFor="let campo of camposAdicionales"
                                >
                                    <div
                                        *ngIf="
                                            !campo.valor || campo.valor !== 0
                                        "
                                        class="field col-12 md:col-4 p-1 mb-0"
                                    >
                                        <label
                                            htmlFor="campo.nombre"
                                            class="etiqueta"
                                            >{{ campo.etiqueta }}</label
                                        >
                                        <ng-container
                                            *ngIf="campo.tipo === 'TEXT'"
                                        >
                                            <input
                                                pInputText
                                                [id]="campo.nombre"
                                                type="text"
                                                [formControlName]="campo.nombre"
                                                [autofocus]="true"
                                            />
                                        </ng-container>
                                        <ng-container
                                            *ngIf="campo.tipo === 'AMOUNT'"
                                        >
                                            <p-inputNumber
                                                [inputId]="campo.nombre"
                                                [formControlName]="campo.nombre"
                                            ></p-inputNumber>
                                        </ng-container>
                                        <ng-container
                                            *ngIf="campo.tipo === 'DATE'"
                                        >
                                            <p-calendar
                                                [inputId]="campo.nombre"
                                                [formControlName]="campo.nombre"
                                                [showTime]="false"
                                                dateFormat="dd/mm/yy"
                                                appendTo="body"
                                            ></p-calendar>
                                        </ng-container>
                                        <ng-container
                                            *ngIf="campo.tipo === 'OPTION'"
                                        >
                                            <p-dropdown
                                                [options]="campo.opciones"
                                                [formControlName]="campo.nombre"
                                                optionLabel="nombre"
                                                optionValue="valor"
                                                appendTo="body"
                                            ></p-dropdown>
                                        </ng-container>
                                        <small
                                            *ngIf="invalidControl(campo.nombre)"
                                            class="campo-invalido"
                                            >Este campo es requerido.</small
                                        >
                                    </div>
                                </ng-container>
                            </div>
                        </ng-container>
                    </form>
                </ng-container>
                <ng-container *ngIf="servicioSeleccionado?.detalles?.length">
                    <div
                        *ngIf="servicioSeleccionado?.campos.length"
                        class="grid"
                    >
                        <div
                            class="col-12"
                            *ngFor="let campo of servicioSeleccionado?.campos"
                        >
                            <div
                                class="grid flex justify-content-center servicio-disponible"
                            >
                                {{ campo.etiqueta }}: {{ campo.valor }}
                            </div>
                        </div>
                    </div>
                    <div class="grid p-1 pt-3">
                        <div
                            class="col-12 md:col-4 p-1"
                            *ngFor="
                                let detalle of servicioSeleccionado?.detalles
                            "
                        >
                            <div
                                [class]="servicioCardClass(detalle)"
                                (click)="onDetalleServicio(detalle)"
                            >
                                <div class="grid">
                                    <ng-container *ngFor="let campo of detalle">
                                        <div
                                            *ngIf="
                                                campo.ocultar === 'false' ||
                                                campo.ocultar === false
                                            "
                                            class="col-12 p-1 pt-2"
                                        >
                                            <label
                                                htmlFor="campo.nombre"
                                                class="etiqueta-detalle"
                                            >
                                                <i
                                                    class="pi pi-check-circle icono-detalle"
                                                ></i>
                                                {{ campo.etiqueta }}
                                            </label>
                                            <ng-container
                                                *ngIf="campo.tipo === 'TEXT'"
                                            >
                                                <label
                                                    htmlFor="campo.valor"
                                                    class="campo-detalle"
                                                    >{{ campo.valor }}</label
                                                >
                                            </ng-container>
                                            <ng-container
                                                *ngIf="campo.tipo === 'AMOUNT'"
                                            >
                                                <label
                                                    htmlFor="campo.valor"
                                                    class="campo-detalle"
                                                    >{{
                                                        campo.valor
                                                            | currency
                                                                : ""
                                                                : ""
                                                                : "0.0"
                                                    }}</label
                                                >
                                            </ng-container>
                                            <ng-container
                                                *ngIf="campo.tipo === 'DATE'"
                                            >
                                                <label
                                                    htmlFor="campo.valor"
                                                    class="campo-detalle"
                                                    >{{
                                                        obtenerFecha(
                                                            campo.valor
                                                        )
                                                    }}</label
                                                >
                                            </ng-container>
                                            <ng-container
                                                *ngIf="campo.tipo === 'OPTION'"
                                            >
                                                <label
                                                    htmlFor="campo.opciones[0].valor"
                                                    class="campo-detalle"
                                                    >{{
                                                        campo.opciones[0].nombre
                                                    }}</label
                                                >
                                            </ng-container>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <hr />
                <div class="grid p-fluid" *ngIf="fgCobro.valid && showBtns">
                    <div class="col-12 md:col-6">
                        <p-button
                            type="button"
                            severity="danger"
                            label="CANCELAR"
                            (onClick)="cancelar()"
                            icon="pi pi-times"
                        ></p-button>
                    </div>
                    <div
                        *ngIf="
                            servicioSeleccionado?.tipoTrx === CONSULTA ||
                            servicioSeleccionado?.tipoTrx === CODIGO_BARRA
                        "
                        class="col-12 md:col-6"
                    >
                        <p-button
                            type="button"
                            severity="info"
                            label="CONSULTAR"
                            (onClick)="consultar()"
                            icon="pi pi-question"
                        ></p-button>
                    </div>
                    <div *ngIf="mostrarBtnPago()" class="col-12 md:col-6">
                        <p-button
                            type="button"
                            severity="success"
                            label="PAGAR"
                            (onClick)="pagar()"
                            icon="pi pi-money-bill"
                        ></p-button>
                    </div>
                </div>
            </ng-container>

            <!-- Modal para confirmar pago de servicio selecionado -->
            <p-dialog
                header="Seguro/a que desea confirmar el pago del servicio?"
                [(visible)]="showModalServicioPago"
                [modal]="true"
                [style]="{ width: '95vw', minWidth: '95vw' }"
                [maximizable]="false"
                [baseZIndex]="10000"
                [closable]="false"
                appendTo="body"
                [closable]="false"
                [draggable]="false"
                [closeOnEscape]="false"
            >
                <p-toast
                    key="td"
                    [baseZIndex]="100000"
                    position="center"
                    [life]="8000"
                ></p-toast>
                <p-toast
                    key="tr"
                    [baseZIndex]="100000"
                    position="top-right"
                    [life]="8000"
                ></p-toast>
                <div *ngIf="loadingPagoServicio" class="overlay">
                    <div class="spinner-container">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                </div>
                <ng-container *ngIf="detalleServicioSeleccionado">
                    <div class="card detalle-card detalle-card-selected">
                        <div class="grid">
                            <ng-container
                                *ngFor="
                                    let campo of detalleServicioSeleccionado
                                "
                            >
                                <div
                                    *ngIf="
                                        campo.ocultar === false ||
                                        campo.ocultar === 'false'
                                    "
                                    class="col-12 md:col-6 p-1 pt-2"
                                >
                                    <label
                                        htmlFor="campo.nombre"
                                        class="etiqueta-detalle"
                                    >
                                        <i
                                            class="pi pi-check-circle icono-detalle"
                                        ></i>
                                        {{ campo.etiqueta }}
                                    </label>
                                    <ng-container *ngIf="campo.tipo === 'TEXT'">
                                        <label
                                            htmlFor="campo.valor"
                                            class="campo-detalle"
                                            >{{ campo.valor }}</label
                                        >
                                    </ng-container>
                                    <ng-container
                                        *ngIf="campo.tipo === 'AMOUNT'"
                                    >
                                        <label
                                            htmlFor="campo.valor"
                                            class="campo-detalle"
                                            >{{
                                                campo.valor
                                                    | currency : "" : "" : "0.0"
                                            }}</label
                                        >
                                    </ng-container>
                                    <ng-container *ngIf="campo.tipo === 'DATE'">
                                        <label
                                            htmlFor="campo.valor"
                                            class="campo-detalle"
                                            >{{
                                                obtenerFecha(campo.valor)
                                            }}</label
                                        >
                                    </ng-container>
                                    <ng-container
                                        *ngIf="campo.tipo === 'OPTION'"
                                    >
                                        <label
                                            htmlFor="campo.opciones[0].valor"
                                            class="campo-detalle"
                                            >{{
                                                campo.opciones[0].nombre
                                            }}</label
                                        >
                                    </ng-container>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <hr />
                </ng-container>
                <ng-container *ngIf="fgCobro">
                    <div class="card detalle-card detalle-card-selected">
                        <div class="grid p-2">
                            <form
                                [formGroup]="fgCobro"
                                class="p-fluid p-formgrid grid"
                            >
                                <div class="field col-12 md:col-3">
                                    <label class="etiqueta-cobro"
                                        >Importe del Servicio</label
                                    >
                                    <p-inputNumber
                                        class="input-cobro valor-cobro"
                                        inputId="mr_importe_servicio"
                                        formControlName="mr_importe_servicio"
                                    ></p-inputNumber>
                                    <small
                                        *ngIf="
                                            invalidControl(
                                                'mr_importe_servicio'
                                            )
                                        "
                                        class="campo-invalido"
                                        >Este campo es requerido.</small
                                    >
                                </div>

                                <div class="field col-12 md:col-3">
                                    <label class="etiqueta-cobro">
                                        Importe a Cobrar</label
                                    >
                                    <p-inputNumber
                                        class="input-cobro valor-cobro"
                                        inputId="importe_cobrado"
                                        formControlName="mr_importe_cobrado"
                                        [autofocus]="true"
                                        (onBlur)="actualizarImporteCobrar()"
                                    ></p-inputNumber>
                                    <small
                                        *ngIf="
                                            invalidControl('mr_importe_cobrado')
                                        "
                                        class="campo-invalido"
                                        >Este campo es requerido.</small
                                    >
                                </div>

                                <div class="field col-12 md:col-3">
                                    <label class="etiqueta-cobro">
                                        Importe Recibido</label
                                    >
                                    <p-inputNumber
                                        class="input-cobro valor-recibido"
                                        inputId="mr_importe_recibido"
                                        formControlName="mr_importe_recibido"
                                        [autofocus]="true"
                                        (onBlur)="calcularVuelto()"
                                    ></p-inputNumber>
                                    <small
                                        *ngIf="
                                            invalidControl(
                                                'mr_importe_recibido'
                                            )
                                        "
                                        class="campo-invalido"
                                        >Este campo es requerido.</small
                                    >
                                </div>

                                <div class="field col-12 md:col-3">
                                    <label class="etiqueta-cobro">
                                        Vuelto</label
                                    >
                                    <p-inputNumber
                                        class="input-cobro valor-vuelto"
                                        inputId="vuelto"
                                        formControlName="mr_vuelto"
                                    ></p-inputNumber>
                                    <small
                                        *ngIf="invalidControl('mr_vuelto')"
                                        class="campo-invalido"
                                        >Este campo es requerido.</small
                                    >
                                </div>
                            </form>
                        </div>
                    </div>
                </ng-container>
                <hr />
                <div class="grid p-fluid">
                    <div class="col-12 md:col-6">
                        <p-button
                            type="button"
                            severity="danger"
                            label="CANCELAR"
                            (onClick)="cancelarPago()"
                            icon="pi pi-times"
                        ></p-button>
                    </div>
                    <div class="col-12 md:col-6">
                        <p-button
                            type="button"
                            severity="success"
                            label="CONFIRMAR"
                            [disabled]="loadingPagoServicio"
                            (onClick)="confirmarPago()"
                            icon="pi pi-money-bill"
                        ></p-button>
                    </div>
                </div>
            </p-dialog>
        </p-dialog>

        <ng-container *ngIf="cajas.length">
            <div class="grid flex justify-content-center" *ngIf="aperturar">
                <h5>SELECCIONE UNA CAJA</h5>
            </div>
            <div class="grid flex justify-content-start" *ngIf="aperturar">
                <ng-container *ngFor="let caja of cajas">
                    <div class="p-3 col-12 md:col-3">
                        <div
                            class="card caja-card p-1"
                            (click)="cajaSeleccionada(caja)"
                        >
                            <div
                                class="flex justify-content-center caja-card-logo"
                            >
                                <img
                                    src="./assets/images/caja-registradora.png"
                                    alt="{{ caja.nombre }}"
                                    style="width: 4rem"
                                />
                            </div>
                            <div
                                class="flex align-items-center justify-content-center p-1"
                            >
                                <span class="caja-nombre">{{
                                    caja.nombre
                                }}</span>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </ng-container>

        <ng-container *ngIf="cajas.length === 0 && aperturar">
            <div class="card">
                <div class="grid">
                    <div class="col-12 flex justify-content-center">
                        <h5 class="text-bloqueado">
                            Aún no se encuentra habilitado para operar,
                            comuníquese con su soporte...
                        </h5>
                    </div>
                    <div class="col-12 flex justify-content-center">
                        <img
                            class="imagen-bloqueado"
                            src="./assets/images/finamsa/logo-dark.png"
                            alt="logo"
                        />
                    </div>
                </div>
            </div>
        </ng-container>

        <p-dialog
            [(visible)]="showImporteApertura"
            position="center"
            [modal]="true"
            header="Importe Inicial"
            [breakpoints]="{ '960px': '75vw', '400px': '95vw' }"
            [style]="{ width: '20vw', padding: '1rem' }"
            [closeOnEscape]="false"
            [closable]="false"
        >
            <div class="p-fluid p-formgrid grid flex justify-content-between">
                <div class="field col-12">
                    <p-inputNumber
                        inputId="importe"
                        [(ngModel)]="saldoInicial"
                    ></p-inputNumber>
                </div>
                <div class="field col-6 entrega">
                    <p-button
                        icon="pi pi-times"
                        label="Cancelar"
                        severity="danger"
                        (click)="cancelarApertura()"
                        with="150"
                    ></p-button>
                </div>
                <div class="field col-6 entrega">
                    <p-button
                        icon="pi pi-check"
                        label="Continuar"
                        (click)="guardarDatos()"
                        with="150"
                    ></p-button>
                </div>
            </div>
        </p-dialog>

        <p-dialog
            [(visible)]="showPrintArqueo"
            position="center"
            [modal]="true"
            header=""
            [breakpoints]="{ '960px': '75vw', '400px': '95vw' }"
            [style]="{ width: '30vw' }"
            [closeOnEscape]="false"
        >
            <app-impresion-arqueo
                [arqueo]="objArqueo"
                [tipoImpresora]="tipoImpresoraBluetooth"
            ></app-impresion-arqueo>
        </p-dialog>

        <p-dialog
            [(visible)]="showPrintCobro"
            position="center"
            [modal]="true"
            header=""
            [breakpoints]="{ '960px': '75vw', '400px': '95vw' }"
            [style]="{ width: '30vw' }"
            [closeOnEscape]="false"
        >
            <app-impresion-cobro
                [cobro]="objCobro"
                [tipoImpresora]="tipoImpresoraBluetooth"
                (eImprimir)="actualizarCobroImpresion(objCobro)"
            ></app-impresion-cobro>
        </p-dialog>
    </ng-container>
</ng-container>
